import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReviewerPerformanceDailyV1Query } from './get-reviewer-performance-daily-v1-request';
import type { IGetReviewerPerformanceDailyV1Response } from './get-reviewer-performance-daily-v1-response';
import { getReviewerPerformanceDailyV1ResponseSchema } from './get-reviewer-performance-daily-v1-response';

export async function getReviewerPerformanceDailyV1Api(
  query: IGetReviewerPerformanceDailyV1Query,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetReviewerPerformanceDailyV1Response>> {
  const params = new URLSearchParams();
  params.set('userId', query.userId);
  if (query.days != null) {
    params.set('days', String(query.days));
  }
  return getRequest<IGetReviewerPerformanceDailyV1Response>({
    path: `/sys/reviewer-performance/v1/daily?${params.toString()}`,
    schema: getReviewerPerformanceDailyV1ResponseSchema,
    options,
  });
}
